import type { Season, WorldState } from "./types";

export const WORLD_RATE = 180;
export const DAY = 24 * 3600;

export function hourOf(timeSec: number): number {
  return ((timeSec % DAY) + DAY) % DAY / 3600;
}

export function dayOf(timeSec: number): number {
  return Math.floor(timeSec / DAY);
}

export function seasonOf(timeSec: number): Season {
  const d = dayOf(timeSec) % 28;
  if (d < 7) return "thaw";
  if (d < 14) return "highsun";
  if (d < 21) return "ember";
  return "ashfall";
}

export function sun(timeSec: number): { elev: number; night: number } {
  const h = hourOf(timeSec);
  const ang = ((h - 6) / 24) * Math.PI * 2;
  const elev = Math.sin(ang);
  const night = elev < 0 ? Math.min(1, -elev) : 0;
  return { elev, night };
}

export function advanceTime(w: WorldState, dt: number): void {
  w.timeSec += dt * WORLD_RATE;
  w.season = seasonOf(w.timeSec);
}

export function clockLabel(timeSec: number): string {
  const h = hourOf(timeSec);
  const hh = Math.floor(h);
  const mm = Math.floor((h - hh) * 60);
  const ap = hh >= 12 ? "PM" : "AM";
  const h12 = ((hh + 11) % 12) + 1;
  return `${h12}:${mm.toString().padStart(2, "0")} ${ap}`;
}
